module.exports = __webpack_public_path__ + "static/media/bg.8390b49d.jpg";